import React from 'react'

const MaintenancePage: React.FC = () => {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f8f9fa',
      padding: '2rem',
      textAlign: 'center'
    }}>
      <div style={{ maxWidth: '480px' }}>
        <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🔧</div>
        <h1 style={{ fontSize: '2rem', fontWeight: 700, color: '#212529', marginBottom: '1rem' }}>
          Under Maintenance
        </h1>
        <p style={{ color: '#6c757d', fontSize: '1.1rem', marginBottom: '2rem', lineHeight: 1.6 }}>
          We are currently performing scheduled maintenance. We will be back online shortly.
          Thank you for your patience.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            backgroundColor: '#0d6efd',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            padding: '0.6rem 1.4rem',
            fontSize: '1rem',
            cursor: 'pointer'
          }}
        >
          Try Again
        </button>
      </div>
    </div>
  )
}

export default MaintenancePage
